import { Controller } from "@hotwired/stimulus"

// Development-only: warn when button hierarchy rules are violated.
export default class extends Controller {
  static values = {
    env: { type: String, default: "production" }
  }

  connect() {
    if (this.envValue !== "development") return

    this.#lintPrimaryButtons()
  }

  #lintPrimaryButtons() {
    const primaries = document.querySelectorAll(".btn-primary")
    if (primaries.length <= 1) return

    const paths = [...primaries].map((el) => {
      const label = el.textContent?.trim().replace(/\s+/g, " ").slice(0, 40)
      return label || el.getAttribute("aria-label") || "(sans libellé)"
    })

    console.warn(
      `[dev-lint] ${primaries.length} boutons primaires sur cette page (attendu: 1).`,
      paths
    )
  }
}
